module.exports = __webpack_public_path__ + "static/media/mv.0fdc08c6.svg";